import React from 'react';
import { Handle, Position, useStore } from 'reactflow';

import CohortNodeCard from '../../../../components/CohortNode';

// Re-render only when the "compact vs expanded" threshold changes (not on every zoom tick).
const compactSelector = (state) => state.transform[2] < 0.65;

const CohortNode = ({
  id,
  data,
  selected,
  targetPosition,
  sourcePosition,
  onEdit,
  onDelete,
  onAddChild,
  onInsert,
  onExecuteToHere,
  onToggleBreakpoint,
  onRename,
}) => {
  const compact = useStore(compactSelector);

  return (
    <>
      {/* Keep handles for correct edge anchoring, but hide them visually */}
      <Handle type="target" position={targetPosition || Position.Left} style={{ opacity: 0 }} />
      <Handle type="source" position={sourcePosition || Position.Right} style={{ opacity: 0 }} />

      <CohortNodeCard
        id={id}
        label={data?.label}
        description={data?.description}
        criteria={data?.criteria}
        criteriaCount={data?.criteriaCount}
        patientCount={data?.patientCount}
        isExecuted={data?.isExecuted}
        status={data?.status}
        isBreakpoint={data?.isBreakpoint}
        selected={selected}
        compact={compact}
        onEdit={onEdit}
        onDelete={onDelete}
        onAddChild={onAddChild}
        onInsert={onInsert}
        onExecuteToHere={onExecuteToHere}
        onToggleBreakpoint={onToggleBreakpoint}
        onRename={onRename}
      />
    </>
  );
};

export default React.memo(CohortNode);
